<script>
    import { lang } from "../scripts/stores";
</script>

<style>
    .info-container {
        max-width: 640px;
        margin-left: auto;
        margin-right: auto;
    }
    ul {
        list-style: circle;
        margin-top: 1.5rem;
        margin-left: 2rem;
        margin-bottom: 2rem;
    }
    li { margin-bottom: 1rem; }

</style>


<div class="info-container">
    {#if $lang === "fi"}
        <h3 style="margin-top: 2rem;">Yhteisvaikutus</h3>
        <p>
            Arvioi vielä kartoituksen päätteeksi aistiympäristöä
            kokonaisuutena. Pohdi ja keskustele muiden tilan
            käyttäjien kanssa:
        </p>

        <ul>
            <li>
                Mikä tiloissa on aistien näkökulmasta
                miellyttävää ja toimivaa?
            </li>
            <li>
                Onko arvioitavassa kohteessa hiljaista tilaa,
                johon on mahdollista vetäytyä
                aistikuormituksen kasvaessa liian suureksi – tai
                olisiko sellaiselle tarvetta?
            </li>
            <li>
                Millaisen kokonaisuuden tilan aistiärsykkeet
                yhdessä muodostavat (huomioikaa
                aistiärsykkeiden kumuloituva vaikutus)?
            </li>
        </ul>

        <a href="/#/results-page" class="btn btn-primary btn-outlined">Näytä yhteenveto</a>    
    {:else}
        <h3 style="margin-top: 2rem;">Combined effect</h3>
        <p>
            Now, at the end of the survey, assess the sensory environment as a whole. Reflect and discuss with other users of the space:
        </p>

        <ul>
            <li>
                What is pleasant and functional from the sensory point of view?
            </li>
            <li>
                Is there a quiet space in the assessed site where it is possible to retreat if the sensory load becomes too great – or would there be need for such a space?

            </li>
            <li>
                What is the combined effect of the sensory stimuli from the space (note the cumulative effect of the sensory stimuli)?
            </li>
        </ul>

        <a href="/#/results-page" class="btn btn-primary btn-outlined">Show results</a>
    {/if}

</div>